import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', redirect: '/explorer' },
  { path: '/create', name: 'create', component: () => import('../views/CreateView.vue') },
  { path: '/create/:chasseId', name: 'edit', component: () => import('../views/CreateView.vue'), props: true },
  { path: '/do/:chasseId', name: 'DoerView', component: () => import('../views/DoerView.vue'), props: true },
  { path: '/explorer', name: 'explorer', component: () => import('../views/ExplorerView.vue') },
  { path: '/profile', name: 'profile', component: () => import('../views/ProfileView.vue') },
  { path: '/search/:query', name: 'search', component: () => import('../views/SearchView.vue'), props: true },
  { path: '/about', name: 'about', component: () => import('../views/AboutView.vue') },
  { path: '/creator/:tag', name: 'creator', component: () => import('../views/CreatorView.vue'), props: true },
  { path: '/chasse/:chasseId', name: 'ChasseView', component: () => import('../views/ChasseView.vue'), props: true },
  { path: '/preview', name: 'preview', component: () => import('../views/PreviewView.vue') },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
